import { render, staticRenderFns } from "./PreparationTimeInput.vue?vue&type=template&id=3d8f6c78&"
import script from "./PreparationTimeInput.vue?vue&type=script&lang=js&"
export * from "./PreparationTimeInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib'
installComponents(component, {
  VSelect,
})
